import { Stack, useLocalSearchParams } from "expo-router";
import { useUnistyles } from "react-native-unistyles";
import { AlarmSettings } from "@src/features/alarms/screens/AlarmSettings";

export default function AlarmSettingsPage() {
  const { theme } = useUnistyles();
  const { siteId, cameraKey } = useLocalSearchParams<{
    siteId?: string;
    cameraKey?: string;
  }>();

  return (
    <>
      <Stack.Screen
        options={{
          title: "Alarm Settings",
          headerShown: true,
          headerStyle: {
            backgroundColor: theme.colors.background,
          },
          headerTintColor: theme.colors.text,
          headerBackButtonDisplayMode: "minimal",
        }}
      />
      <AlarmSettings cameraKey={cameraKey} siteId={siteId} showCameraSelection={false} />
    </>
  );
}
